import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { useGiftOffer, isHolidayPrice, fmtPrice } from "@/lib/giftOffer";

export default function GiftEReaderButton({ testId = "gift-ereader-button", compact = false }) {
  const offer = useGiftOffer();
  if (compact) {
    return (
      <Link to="/reader/gift" data-testid={testId} className="btn-ghost px-8 py-4 flex items-center gap-2 font-mono-ui text-xs uppercase tracking-[0.18em]">
        <Gift className="w-4 h-4 text-primary-gold" /> Give the E-Reader
      </Link>
    );
  }
  return (
    <Link
      to="/reader/gift"
      data-testid={testId}
      className="group mt-6 flex items-center gap-4 border border-primary-gold/30 bg-primary-gold/5 px-5 py-4 hover:bg-primary-gold/10 transition-colors"
    >
      <Gift className="w-5 h-5 text-primary-gold shrink-0" />
      <span className="flex-1">
        <span className="block font-mono-ui text-[10px] uppercase tracking-[0.22em] text-primary-gold">Give the E-Reader</span>
        <span className="block text-sm text-soft mt-1">
          Gift 40 days of all four novels, read aloud — {offer ? fmtPrice(offer.gift_price) : "$15.00"}
          {isHolidayPrice(offer) && <span className="ml-2 text-primary-gold" data-testid={`${testId}-holiday`}>holiday price</span>}
        </span>
      </span>
      <ArrowRight className="w-4 h-4 text-primary-gold transition-transform group-hover:translate-x-1" />
    </Link>
  );
}
